import { SUPPORT_EMAIL } from "../consts";

type SupportLinkOptions = {
  tone?: "link" | "inherit";
  testId?: string;
};

export const withSupportLink = (
  sentence: string,
  {
    tone = "link",
    testId = "sub_ib_report_support_email_link",
  }: SupportLinkOptions = {},
) => {
  const [before, ...rest] = sentence.split(SUPPORT_EMAIL);
  if (rest.length === 0) return sentence;
  return (
    <>
      {before}
      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        data-testid={testId}
        className={
          tone === "inherit"
            ? "text-inherit underline hover:text-text-primary"
            : "text-text-link-default underline hover:text-text-brand-bold"
        }
      >
        {SUPPORT_EMAIL}
      </a>
      {rest.join(SUPPORT_EMAIL)}
    </>
  );
};
